import { Tooltip } from "@mui/material";
import { DateComponent, DateVariant } from "components/base/DateComponent";
import { INameProvider, UserName } from "features/solution-member";
import prettyBytes from "pretty-bytes";
import { useCallback, useEffect, useState } from "react";
import "./dataGridView.css";

export const DateCellRenderer = ({ value }: { value?: Date }) => {
  if (!value) return;
  return (
    <Tooltip
      title={<DateComponent date={value} variant={DateVariant.DETAILED} />}
      classes={{ tooltip: "tooltip" }}
    >
      <div>
        <DateComponent date={value} variant={DateVariant.RELATIVE} />
      </div>
    </Tooltip>
  );
};

export const BytesCellRenderer = ({ value }: { value?: number }) => {
  if (!value) return;
  return (
    <Tooltip title={value} classes={{ tooltip: "tooltip" }}>
      <div>{prettyBytes(value)}</div>
    </Tooltip>
  );
};

export const DateTickerCellRenderer = ({ value }: { value: Date }) => {
  const [, forceUpdate] = useState({});

  const tick = useCallback(() => {
    forceUpdate({});
  }, []);

  useEffect(() => {
    const intervalID = setInterval(() => tick(), 15000);
    return () => clearInterval(intervalID);
  }, [tick]);

  return (
    <DateComponent
      date={value}
      variant={DateVariant.RELATIVE}
      relativeOptions={{ includeSeconds: true, addSuffix: true }}
    />
  );
};

type UserNameCellRendererProps = {
  user: INameProvider & { name: string };
};

export function UserNameCellRenderer({ user }: UserNameCellRendererProps) {
  if (!user) return null;
  return <UserName data={user} />;
}
